import React from "react";
const Loading = () => (
    <div className="loading">

    </div>
);

export default Loading;
